import { ElementIdentifier } from '@wix/editor-platform-sdk-types';

export const getIdentifierFromRoleAndSubRole = ({
  subRole,
  role,
}: ElementIdentifier) => (subRole ? `R-${role}:S-${subRole}` : `R-${role}`);
